import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustAuthority from "@/components/site/TrustAuthority";
import Services from "@/components/site/Services";
import Fomo from "@/components/site/Fomo";
import WhyChoose from "@/components/site/WhyChoose";
import InquiryForm from "@/components/site/InquiryForm";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-[#050505] text-white" data-testid="home-page">
      <Navbar />
      <Hero />
      <TrustAuthority />
      <Services />
      <Fomo />
      <WhyChoose />
      <InquiryForm />
      <Footer />
    </main>
  );
}
